/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-07-05 09:21:29
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-09-23 17:38:20
 * @FilePath: /vue_huaqiang/src/store/modules/permission.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from "vuex-module-decorators";
import { RouteConfig } from "vue-router";
import { _404Route, asyncRoutes, constantRoutes,_401Route } from "@/router";
import store from "@/store";

export const matchRouteConfigByRoute = (
  fixRouter: RouteConfig[],
  ArrRoute: RouteConfig[]
) => {
  const res: RouteConfig[] = [];
  ArrRoute.forEach((server) => {
    const route: RouteConfig = fixRouter.filter(
      (r) => r.path === server.path
    )[0];
    if (route) {
      const r = { ...route };
      if (route.children?.length > 0) {
        r.children = matchRouteConfigByRoute(route.children, server.children);
      }
      r.meta.buttonCodes = server.meta.buttonCodes;
      res.push(r);
    }
  });
  return res;
};

export interface IPermissionState {
  routes: RouteConfig[];
  dynamicRoutes: RouteConfig[];
}

@Module({ dynamic: true, store, name: "permission" })
class Permission extends VuexModule implements IPermissionState {
  public routes: RouteConfig[] = [];
  public dynamicRoutes: RouteConfig[] = [];

  @Mutation
  private async SET_ROUTES(routes: RouteConfig[]) {
    this.routes = constantRoutes.concat(routes);
    // function fn(arr) {
    //   return arr.map(item => {
    //     if(item.children && item.children.length > 0) {
    //       fn(item.children)
    //     } else {
    //       delete item.children
    //     }
    //     return item
    //   })
    // }
    // this.routes = fn(routes)
    // this.routes = routes
    this.dynamicRoutes = routes;
    // console.log('获取到的routes',routes)
  }
  

  @Action
  public GenerateRoutes(serverRoutes: RouteConfig[]) {
    // console.log('获取到的serverRoutes',serverRoutes)
    // console.log('获取到的asyncRoutes',asyncRoutes)
    const routes = matchRouteConfigByRoute(asyncRoutes, serverRoutes);

    // const routes = asyncRoutes // 使用本地路由
    console.log('获取到的routes', routes)
    this.SET_ROUTES(routes.concat(_404Route));
    this.SET_ROUTES(routes.concat(_401Route));
  }
}

export const PermissionModule = getModule(Permission);
